var _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVscodeIconsFileTypeCss(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 63,
    viewBox: "0 0 63 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6196 53.552L7.19775 3.9375H55.8022L51.3745 53.5441L31.4705 59.0625L11.6196 53.552Z",
    fill: "#1572B6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5 54.8455L47.5847 50.3862L51.3686 7.99512H31.5V54.8455Z",
    fill: "#33A9DC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5 25.9698H39.5522L40.1074 19.7387H31.5V13.6533H46.7578L46.6121 15.2854L45.1178 32.0552H31.5V25.9698Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5374 41.773L31.5098 41.7808L24.7334 39.9499L24.3003 35.0969H18.1912L19.0437 44.6513L31.5079 48.1123L31.5374 48.1045V41.773Z",
    fill: "#EBEBEB"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M39.0344 31.7974L38.302 39.946L31.5157 41.777V48.1085L43.9897 44.6513L44.0823 43.6236L45.1395 31.7974H39.0344Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5217 13.6533V19.7387H16.823L16.7009 18.3704L16.4233 15.2854L16.2776 13.6533H31.5217ZM31.5 25.9698V32.0552H24.8082L24.6862 30.6869L24.4105 27.6019L24.2648 25.9698H31.5Z",
    fill: "#EBEBEB"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVscodeIconsFileTypeCss);
export default __webpack_public_path__ + "static/media/vscode-icons_file-type-css.4889f4a7a3b5dc38391cdc0f6d53df68.svg";
export { ForwardRef as ReactComponent };